module.exports = require('./lib/client');



//////////////////
// WEBPACK FOOTER
// ./~/feathers-socket-commons/client.js
// module id = 536
// module chunks = 11